import * as OvationsApi from 'core/ovations-api';

export const mockAddressValidationResult: OvationsApi.Types.AddressValidationResult = {
    isValid: false,
    originalAddress: {
        address1: 'address 1',
        address2: 'address 2',
        city: 'city',
        state: 'state',
        zip: '12345',
        country: 'USA',
    },
    suggestedAddress: {
        address1: 'address 1',
        address2: 'address 2',
        city: 'city',
        state: 'state',
        zip: '12345-1234',
        country: 'USA',
    },
};

export default mockAddressValidationResult;

export const mockAddressValidationNotFound: OvationsApi.Types.AddressValidationResult = {
    isValid: false,
    originalAddress: {
        ...mockAddressValidationResult.originalAddress,
    },
    suggestedAddress: null,
};

export const mockAddressValidationValid: OvationsApi.Types.AddressValidationResult = {
    isValid: true,
    originalAddress: {
        ...mockAddressValidationResult.originalAddress,
    },
    suggestedAddress: null,
};

export const emptyAddressValidationResult: OvationsApi.Types.AddressValidationResult = {
    isValid: false,
    originalAddress: {
        address1: '',
        address2: '',
        city: '',
        state: '',
        zip: '',
        country: '',
    },
    suggestedAddress: {
        address1: '',
        address2: '',
        city: '',
        state: '',
        zip: '',
        country: '',
    },
};
